import { Button, Checkbox, Chip, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextareaAutosize, Typography, useTheme } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationMeet from "../../../../../../../assets/animation/Virtual Meeting.json"
import Lottie from "react-lottie"
import { act, Dispatch, SetStateAction, useState } from "react"
import { LoadingButton } from "@mui/lab"
import { ClientsService } from "../../../../../../../services/clients"


interface Props {
    open: boolean,
    onClose: () => void,
    onConfirm: () => void,
}

const options = {
    loop: true,
    autoplay: true,
    animationData: animationMeet,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalBusinessActivity = ({
    onClose,
    onConfirm,
    open
}: Props) => {
    const { palette } = useTheme()
    const [loading, setLoading] = useState(false)
    const [days, setDays] = useState<number[]>([])
    const [activity, setActivity] = useState("")
    const [step, setStep] = useState(0)

    const update = () => {
        if (step === 0) {
            setStep(step + 1)
        } else {
            setLoading(true)
            ClientsService.updateBusinessActivity({
                workdays: days,
                workDescription: activity
            })
                .then(() => {
                    onConfirm()
                })
                .finally(() => setLoading(false))
        }
    }

    return (
        <ModalComponent
            open={open}
            withoutHeader
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >

                <div style={{ width: "30rem", height: 'auto' }}>
                    <Lottie options={options} />
                </div>

                <Typography fontWeight={700} textAlign={"center"} fontSize={"2rem"}>Queremos conhecer um pouco mais do funcionamento da sua empresa</Typography>

                {step === 0
                    ?
                    <>
                        <Typography fontSize={"1.4rem"} sx={{ opacity: .5 }} textAlign={"justify"}>
                            Marque abaixo apenas os dias da semana em que sua empresa funciona
                        </Typography>

                        <DaysSelector days={days} setDays={setDays} disabled={loading} />
                    </>
                    :
                    <>
                        <Typography fontSize={"1.4rem"} sx={{ opacity: .5 }} textAlign={"justify"}>
                            Escreva em poucas palavras sobre a atividade principal da sua empresa
                        </Typography>

                        <TextareaAutosize
                            placeholder="Exemplo: somos uma confeitaria de bolos e salgados"
                            minRows={3}
                            style={{
                                width: "95%",
                                border: "1px solid #80808070",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "1.5rem",
                                outline: "none",
                                fontFamily: "Inter",
                                transition: "border-color 0.2s ease",
                            }}
                            onFocus={(e) =>
                                (e.target.style.border = `2px solid ${palette.primary.main}`)
                            }
                            autoFocus
                            onBlur={(e) => (e.target.style.border = "1px solid #80808070")}
                            value={activity}
                            onChange={(e) => setActivity(e.target.value)}
                            maxLength={512}
                            disabled={loading}
                        />
                        <Typography fontSize={"1rem"} sx={{ opacity: .5 }} textAlign={"end"} width={"100%"} mt={"-1.3rem"}>
                            Mínimo de 40 caracteres
                        </Typography>
                    </>
                }


                <LoadingButton variant="contained" disabled={step === 0 ? days.length < 2 : activity.length < 40} loading={loading} onClick={update}>Continuar</LoadingButton>
                <Button
                    sx={{
                        height: "4rem",
                        color: "gray"
                    }}
                    onClick={onClose}
                >Cancelar</Button>
            </Grid>

        </ModalComponent >
    )
}



export default function DaysSelector({
    days,
    setDays,
    disabled
}: {
    days: number[];
    setDays: Dispatch<SetStateAction<number[]>>,
    disabled: boolean
}) {
    const weekDays = [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
    ];

    const toggleDay = (index: number) => {
        if (days.includes(index)) {
            setDays(days.filter((item) => item !== index));
        } else {
            setDays((prev) => [...prev, index]);
        }
    };

    return (
        <Grid
            sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 1,
            }}
        >
            {weekDays.map((day, index) => (
                <Chip
                    key={day}
                    label={day}
                    onClick={() => toggleDay(index)}
                    color={days.includes(index) ? "primary" : "default"}
                    variant={days.includes(index) ? "filled" : "outlined"}
                    tabIndex={-1}
                    sx={{
                        fontSize: "1.2rem",
                        cursor: "pointer",
                        "&:focus": {
                            outline: "none",
                            boxShadow: "none",
                            backgroundImage: "none",
                        },
                        "&:focus-visible": {
                            outline: "none",
                            boxShadow: "none",
                            backgroundImage: "none",
                        },
                    }}
                    disabled={disabled}
                />
            ))}
        </Grid>
    );
}

